import carousel    from '@js/sections/home/carousel'
import contact     from '@js/sections/home/contact'
import data        from '@js/sections/home/data'
import hero        from '@js/sections/home/hero'
import information from '@js/sections/home/information'
import live        from '@js/sections/home/live'
import debounce    from 'lodash.debounce'

$(() => {
	window.addEventListener('load', () => {
		hero.init()
		live.init()
		carousel.init()
		information.init()
		data.init()
		contact.init()
	})
})

let previousWidth = window.innerWidth

window.addEventListener('resize', debounce(() => {
	// Only if the window width changed
	if (previousWidth === window.innerWidth) {
		return
	}

	previousWidth = window.innerWidth

	window.scrollTo(0, 0)

	setTimeout(() => {
		window.ScrollTrigger.refresh()
	}, 100)
}, 100))
